// extracted by mini-css-extract-plugin
export var label = "_c6-1";
export var reminder = "_c6-0";